var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { SubscriptionStatus } from '../enum/subscription-status.enum.js';
import { SubscriptionInterval } from '../enum/SubscriptionInterval.enum.js';
export class SubscriptionLiteDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    subscriptionStripeId;
    endingOn;
    cancelAt;
    isTrialPeriod;
    isPaused;
    status;
    rawData;
    interval;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], SubscriptionLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], SubscriptionLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], SubscriptionLiteDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], SubscriptionLiteDto.prototype, "officeLocationId", void 0);
__decorate([
    Exclude(),
    IsString(),
    __metadata("design:type", String)
], SubscriptionLiteDto.prototype, "subscriptionStripeId", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], SubscriptionLiteDto.prototype, "endingOn", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Object)
], SubscriptionLiteDto.prototype, "cancelAt", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], SubscriptionLiteDto.prototype, "isTrialPeriod", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], SubscriptionLiteDto.prototype, "isPaused", void 0);
__decorate([
    Expose(),
    IsEnum(SubscriptionStatus),
    __metadata("design:type", String)
], SubscriptionLiteDto.prototype, "status", void 0);
__decorate([
    Exclude(),
    IsString(),
    __metadata("design:type", Object)
], SubscriptionLiteDto.prototype, "rawData", void 0);
__decorate([
    Expose(),
    IsEnum(SubscriptionInterval),
    IsOptional(),
    __metadata("design:type", Object)
], SubscriptionLiteDto.prototype, "interval", void 0);
//# sourceMappingURL=subscription.lite.dto.js.map